import styled, { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { interactiveTransition, theme } from 'modules/tetrisTheme';
import { getStylesBySelected } from './utils/getStylesBySelected';
const ButtonStyling = css `
  outline: none;
  padding: ${theme.spacing.sm};
  min-width: ${theme.spacing['3xl']};
  min-height: ${theme.spacing['3xl']};
  box-sizing: border-box;
  background-color: transparent;
  border: none;
  border-radius: ${theme.borderRadius.circle};

  &:focus-visible {
    box-shadow: 0 0 0 ${pxToRem(4)} ${theme.semantic.focus.ring};
  }

  &:hover {
    background-color: ${theme.semantic.surface.sunken};
  }

  &:disabled {
    background-color: transparent;
  }

  ${interactiveTransition};
`;
export const PaginationPage = styled.button `
  ${ButtonStyling};
  color: ${theme.semantic.text[100]};

  &:disabled {
    color: ${theme.swatches.warm[500]};
  }

  ${(props) => props.$selected && getStylesBySelected()};
`;
export const PaginationArrowButton = styled.button `
  ${ButtonStyling};
  & svg {
    color: ${theme.semantic.foreground.primary};
  }

  &:disabled svg {
    color: ${theme.swatches.warm[500]};
  }
`;
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.sm};
`;
